import { useState, useEffect } from 'react'
import { useFirestore } from '../../hooks/useFirestore'

import styles from './Home.module.css'

export default function TransactionForm({ uid }) {
  const [name, setName] = useState('')
  const [amount, setAmount] = useState('')
  const { addDocument, response } = useFirestore('transactions')

  const handleSubmit = (e) => {
    e.preventDefault()
    addDocument({
      uid,
      name,
      amount,
      rl1: false,
      rl2: false
    })
    setName('')
    setAmount('')
  }

  // reset the form fields
  //   useEffect(() => {
  //   if (response.success) {
  //     setName('')
  //     setAmount('')
  //     console.log('Set name amount to 0')
  //   }
  // }, [response.success])

  return (
    <>
      {/* <h3>Add a Todo or Shopping Item</h3> */}
      <form onSubmit={handleSubmit}>
        <label>
          {/* <div className='styles.btn4a'> */}
            <span>Shopping Item: (sorts A-Z to group items, P apples...)</span>
            {/* <button>Add a Shopping Item</button> */}
          {/* </div> */}
          <input
            type="text"
            required
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
        </label>
        {/* <label>
          <span>Amount ($):</span>
          <input
            type="number"
            required
            onChange={(e) => setAmount(e.target.value)}
            value={amount}
          />
          </label> */}
        <button>Add a Shopping Item</button>
      </form>
    </>
  )
}